'use client';
import React from 'react';
import { Autocomplete, Paper, Grid, TextField, Typography, Box, Stack, Divider, Card, CardContent, CardHeader, Button, Fade, Switch, FormControlLabel } from "@mui/material";
import HouseIcon from '@mui/icons-material/House';
import {states, usState} from "../../Models/states";
import { LocationInfoModel, LocationInfoErrors } from '@/app/Models/LocationInfoModel';

interface Props {
    data: LocationInfoModel,
    setData: (model: LocationInfoModel) => void;
    errors: LocationInfoErrors;
}

const LocationCard: React.FC<Props> = (props) => {
    
    return (
        <Card sx={{ minWidth: 275}} variant="outlined">
            <CardHeader title='Residence Information'
                avatar={
                    <HouseIcon />
                }/>
            <CardContent>
                <TextField
                    required
                    variant="standard"
                    value={props.data.address}
                    error={props.errors.addressError}
                    onChange={(e) => props.setData({...props.data, address: e.target.value})}
                    id="p-address-textfield"
                    label="Address" />
                <TextField
                    required
                    variant="standard"
                    value={props.data.city}
                    error={props.errors.cityError}
                    onChange={(e) => props.setData({...props.data, city: e.target.value})}
                    id="p-city-textfield"
                    label="City" />
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "flex-end",
                        flexWrap: "wrap",
                        gap: 1,
                        '&& .p-state-select': { width: { xs: '250%', sm: '300px' } },
                        '&& .p-zip-textfield': { width: { xs: '100%', sm: '180px' } },
                    }}
                >
                    <Autocomplete
                        id="p-state-select"
                        value={props.data.state}
                        onChange={(e: any, newValue: usState | null) => {props.setData({...props.data, state: newValue})}}
                        options={states}
                        renderInput={(params) => <TextField {...params} label="State" className="p-state-select" />} />
                    <TextField
                        required
                        variant="standard"
                        value={props.data.zip}
                        error={props.errors.zipError}
                        onChange={(e) => props.setData({...props.data, zip: e.target.value})}
                        id="p-zip-textfield"
                        className="p-zip-textfield"
                        label="Zip Code"
                    />
                </Box>
            </CardContent>
        </Card>
    );
};

export default LocationCard;
